"use client";

import React, { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { FileText, X, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
const availablePuppies = [{
  name: "Black and Tan Male \"Gander\"",
  description: "Black and Tan Male one year old puppy available. Birth date 9/16/25",
  image: "https://cobrnik.com/wp-content/uploads/2026/10/Gander.jpeg?v=qgcgs8vo5jp",
  isAvailable: true,
  pedigreeUrl: "https://cobrnik.com/wp-content/uploads/2026/10/Gander-ped-1-4-rotated.jpeg"
}, {
  name: "Cobrnik Weekend Glory \"Maya\"",
  description: "Retired Black and Tan show girl for sale. Birth date 6/27/23",
  image: "https://cobrnik.com/wp-content/uploads/2026/10/Maya-head-shot-scaled.jpg?v=pirltyxexln",
  isAvailable: true,
  pedigreeUrl: "https://cobrnik.com/wp-content/uploads/2026/04/maya-ped-e1776724609504.jpeg"
}];
export default function AvailablePuppiesSection() {
  const [selectedPedigree, setSelectedPedigree] = useState<string | null>(null);
  if (availablePuppies.length === 0) {
    return <section className="bg-background py-24 text-center">
        <div className="container mx-auto px-4">
          <Heart className="w-12 h-12 text-primary/30 mx-auto mb-4" />
          <h2 className="font-serif text-3xl text-primary">No Puppies Available</h2>
          <p className="text-muted-foreground mt-2">
            We don't have any puppies available at this moment. Please check back soon!
          </p>
        </div>
      </section>;
  }
  return <section id="available-puppies" className="bg-background text-foreground py-24 overflow-hidden relative scroll-mt-24">
      {selectedPedigree && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 md:p-10 animate-in fade-in duration-300">
          <Button onClick={() => setSelectedPedigree(null)} variant="ghost" className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-lg p-2 h-auto">
            <X className="w-6 h-6" />
          </Button>
          <div className="relative max-w-5xl w-full max-h-full overflow-auto rounded-lg shadow-2xl">
            <img src={selectedPedigree} alt="Pedigree View" className="w-full h-auto object-contain bg-white" />
          </div>
        </div>}

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-4xl font-light tracking-tight sm:text-5xl md:text-6xl text-primary">Available</h2>
          <p className="mt-6 text-lg text-muted-foreground font-sans max-w-2xl leading-relaxed mx-auto">
            Find your new best friend. All of our puppies are raised in our home with love, socialization, and health as our top priorities. Retired dogs may also come available when they are done breeding and showing.&nbsp;
          </p>
        </div>

        <ScrollArea className="w-full whitespace-nowrap pb-8">
          <div className="flex w-full justify-center space-x-6 sm:space-x-8">
            {availablePuppies.map((puppy, i) => <div key={i} data-index={i} className="group relative w-[85vw] shrink-0 sm:w-[340px] md:w-[380px] flex flex-col items-center text-center">
                <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted/40 border border-secondary/40 rounded-sm flex items-center justify-center">
                  <img src={puppy.image} alt={puppy.name} className="max-h-full max-w-full object-contain transition-all duration-1000 ease-out group-hover:scale-102 !opacity-[1]" />
                </div>

                <div className="mt-6 flex flex-col items-center gap-1 w-full">
                  <h3 className="font-serif text-3xl font-medium text-foreground tracking-tight whitespace-normal">
                    {puppy.name}
                  </h3>
                  
                  <p className="text-base text-muted-foreground font-sans whitespace-normal line-clamp-4 mt-2 max-w-[90%]">
                    {puppy.description}
                  </p>

                  <div className="mt-5 flex flex-wrap justify-center gap-3 w-full">
                    {puppy.pedigreeUrl ? <Button onClick={() => setSelectedPedigree(puppy.pedigreeUrl)} variant="outline" className="flex items-center gap-2 rounded-lg border-primary/30 text-primary hover:bg-primary hover:text-white transition-all duration-300 px-6">
                        <FileText className="w-4 h-4" />
                        Pedigree
                      </Button> : <Button disabled variant="outline" className="flex items-center gap-2 rounded-lg border-muted text-muted-foreground bg-muted/10 cursor-not-allowed opacity-60 px-6 whitespace-normal">
                        <FileText className="w-4 h-4 opacity-50" />
                        Pedigree Coming Soon
                      </Button>}
                  </div>
                </div>
              </div>)}
          </div>
          <ScrollBar orientation="horizontal" className="hidden sm:flex h-1.5 bg-secondary/20" />
        </ScrollArea>
      </div>
    </section>;
}